import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiError, apiErrorFromHttpErrorResponse } from '../models/api-error.model';

/**
 * Interceptor global que anexa um objeto `apiError: ApiError` tipado em cada
 * HttpErrorResponse, sem consumir o erro (rethrow). Componentes/services podem
 * ler `(err as HttpErrorResponse & { apiError?: ApiError }).apiError` para
 * pegar o codigo/mensagem/detalhes de forma uniforme.
 *
 * IMPORTANTE: registrar APOS o AuthInterceptor no app.module.ts, para nao
 * quebrar o fluxo silencioso de refresh em 401.
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse) {
          const apiError: ApiError = apiErrorFromHttpErrorResponse(err);
          (err as HttpErrorResponse & { apiError?: ApiError }).apiError = apiError;
        }
        return throwError(() => err);
      })
    );
  }
}
